"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAPIKey = getAPIKey;
exports.getWrapperURL = getWrapperURL;
exports.getInternalWrapperURL = getInternalWrapperURL;
exports.API_KEY_API2 = void 0;

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

/**
 * Client API Codes
 */
var API_KEY_API2 = {
  NON_PROD: 'NdLEU0A09QmqiHh2qCGcr6tiRjRYJjo6',
  PROD: 'zPyKlRW5SMxWmCjLDl17Ga39Zig0olrb'
};
/**
 * Returns API for a given environment
 * @returns {String}
 */

exports.API_KEY_API2 = API_KEY_API2;

function getAPIKey() {
  return (0, _uigCurrentEnvironmentUtil.getCurrentEnv)() === 'production' ? API_KEY_API2.PROD : API_KEY_API2.NON_PROD;
}
/**
 * Base URL for sfly-sso server and other service endpoints
 * @returns {String}
 */


function getWrapperURL() {
  return "https://api2.".concat((0, _uigCurrentEnvironmentUtil.getBaseHostname)(), "/v1/optimizely-wrapper");
}
/**
 *  URL for admin functions not accessible by shutterfly customers.
 */


function getInternalWrapperURL() {
  return "https://optimizely-wrapper.".concat((0, _uigCurrentEnvironmentUtil.getBaseHostname)(), "/_internal");
}

//# sourceMappingURL=Utils.js.map